module.exports = "<div class=inmodal> <div class=modal-header> <h3 class=modal-title><i class=\"fa fa-exclamation-triangle text-warning\" aria-hidden=true></i>&nbsp;{{ctrl.title}}</h3> </div> <div class=modal-body style=background:#fff> <h4>{{ctrl.message}}</h4> </div> <div class=modal-footer> <button type=button class=\"btn btn-primary\" ng-click=ctrl.ok()>{{ctrl.btnOk}}</button> <button type=button class=\"btn btn-white\" ng-click=ctrl.cancel()>Отмена</button> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/confirmation.html
// module id = 7
// module chunks = 0